import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/delivery/inquiries/")({
  head: () => ({
    meta: [{ title: "询盘管理 · imiker CRM" }],
  })
});
